import React from 'react'
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap'
import { Breadcrumbs } from '../../AbstractElements'
import HeaderCard from '../Common/Component/HeaderCard'
import { useNavigate, useParams } from 'react-router-dom'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const AdminInstructorSuccess = () => {
	const navigate = useNavigate()
	const { id } = useParams()
	const layout = useLayout()
	const role = useRoleBasedUrl()

	const handleSubmit = async (e) => {
		e.preventDefault()
		navigate(`${process.env.PUBLIC_URL}/${role}/instructors/detail/${id}/${layout}`)
	}

	return (
		<>
			<Breadcrumbs parent="Instructor Management" title="Add Instructor" mainTitle="Add Instructor" />
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<HeaderCard title="Add Instructor" subTitle="Instructor creation completed" />
							<CardBody>
								<div className="row mx-auto">
									<div className="add-course-msg">
										<i className="fas fa-circle-check"></i>
										<h4>The Instructor Added Successfully</h4>
										<p></p>
									</div>

									<div className="update-profile d-flex justify-content-between">
										<Button type="button" color="primary" onClick={handleSubmit}>
											Next Step {'>>'}
										</Button>
										<Button type="button" color="secondary" onClick={() => navigate(`${process.env.PUBLIC_URL}/${role}/instructors/${layout}`)}>
											Cancel
										</Button>
									</div>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	)
}

export { AdminInstructorSuccess }
